import { useSession } from 'next-auth/react';
import { useGetInfiniteQuery } from '~/shared/utils';
import { useClubPaths } from '../hooks/useClubPaths';
import {
    OrderHistoryViewModel,
} from '~/lib/data-contract';

export const useOrderHistory = (pageSize?: number) => {
    const { data: session, status: sessionStatus } = useSession();
    const {
        getOrderHistoryUrl,
    } = useClubPaths();

    const headers = session?.accessToken
        ? { Authorization: `Bearer ${session.accessToken}` }
        : undefined;

    const isAuthenticated = sessionStatus === 'authenticated' && Boolean(session?.accessToken);

    return useGetInfiniteQuery<OrderHistoryViewModel>(getOrderHistoryUrl, {
        headers,
        enabled: isAuthenticated,
        pageSize: pageSize || 10, // Default to 10 orders per page
        getNextPageParam: (lastPage, _allPages) => {
            // Check if there are more pages based on the API response
            const currentPage = lastPage?.page ?? 0;
            const totalPages = lastPage?.totalPages ?? 0;
            
            if (currentPage < totalPages - 1) {
                return { page: currentPage + 1 };
            }
            return undefined; // No more pages
        },
    });
};
